const IDEA_API = 'https://receipt.bucksimple.com/api/ideas'
const pendingRequestIds = new Map<string, string>()

export type IdeaIdentity = {
  signedIn: boolean
  email: string | null
}

export async function loadIdeaIdentity(): Promise<IdeaIdentity> {
  const response = await fetch(IDEA_API, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  })
  if (!response.ok) return { signedIn: false, email: null }
  return response.json() as Promise<IdeaIdentity>
}

export async function sendAppIdea(input: {
  idea: string
  replyEmail: string
}): Promise<{ delivered: boolean }> {
  const fingerprint = [
    window.location.origin,
    window.location.pathname,
    input.replyEmail.trim().toLowerCase(),
    input.idea.trim(),
  ].join('\n')
  const requestId = pendingRequestIds.get(fingerprint) || crypto.randomUUID()
  pendingRequestIds.set(fingerprint, requestId)
  const response = await fetch(IDEA_API, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Idempotency-Key': requestId,
    },
    body: JSON.stringify({
      idea: input.idea,
      replyEmail: input.replyEmail,
      sourcePath: window.location.pathname,
      website: '',
    }),
  })
  const result = (await response.json().catch(() => null)) as {
    error?: string
    delivered?: boolean
  } | null
  if (!response.ok && response.status !== 202) {
    throw new Error(result?.error || 'Your idea could not be sent. Please try again.')
  }
  pendingRequestIds.delete(fingerprint)
  return { delivered: result?.delivered === true }
}
